import React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png";
import meeting1 from "../static/img/meetingWithShkaruba.jpg";
import "./Microcredit.style.scss";

const OnlineNextMeeting: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);
    return (
        <div style={{marginTop:"30px",marginBottom:"20px"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>
            <h1>
                {en ? "Online meeting of Ukrainian partners with project coordinator Anton Shkaruba" :
                    "Онлайн-зустріч  українських партнерів з координатором проєкту Антоном Шкаруба"}
            </h1>
            <p style={{fontWeight:"inherit",fontSize: "20px",margin:"30px 120px 30px 120px",textAlign:"left"}}>
                {en ? (<>
                        On December 17, 2025, an online meeting was held between representatives of Ukrainian universities
                     participating in the project—Nadiya Maksymenko (V. N. Karazin Kharkiv National University, Kharkiv)
                     and Olga Shevchenko (Taras Shevchenko National University of Kyiv, Kyiv) with DOMANI project coordinator
                     Anton Shkaruba (Estonian University of Life Sciences, Tartu).<br />
                      The meeting is dedicated to discussing the next steps in the development of the following elements of
                     microcredit programs:<br/>
                     ✓ Course program (in English and the national language, if applicable)<br />
                     ✓ Video presentation of the course (in English and the national language, if applicable)<br />
                     ✓ Course poster<br />
                     ✓ E-learning course presentation (in English and the national language, if applicable)<br/>
                     ✓ Video lectures and/or seminars and/or (Word or TXT file with YouTube links)<br/>
                     ✓ Availability of the course in Moodle to provide e-learning for the course.<br />
                     Attention was also drawn to the review, certification, and launch of the developed courses.
                     At the end of the meeting, all participants conveyed their greetings to their colleagues' teams
                      for the upcoming Christmas and New Year holidays.
                    </>):
                    (<>
                    17 грудня 2025 року відбулась онлайн зустріч представників українських університетів – виконавців
                     проєкту – Надії Максименко (Харківський національний університет імені  В. Н. Каразіна, м. Харків)
                     та Ольги Шевченко (Київський національний університет імені Т.Г. Шевченка, м. Київ.) з представником
                    координаторів проєкту DOMANI Антоном Шкаруба (Естонський університет наук про життя, м. Тарту).<br/>
                    Нарада присвячена обговоренню питань наступних кроків в оформленні таких елементів мікрокредитних програм як: <br />
                        ✓ Програма курсу (англійською та національною мовою, якщо це доречно)<br/>
                        ✓ Відеопрезентація курсу (англійською та національною мовою, якщо це доречно)<br />
                        ✓ Афіша курсу<br/>
                        ✓ Презентація курсу електронного навчання (англійською та національною мовою, якщо це доречно)<br/>
                        ✓ Відеолекції та/або семінари та/або (файл Word або TXT із посиланнями на YouTube)<br/>
                        ✓ Наявність курсу у Moodle для забезпечення електронного навчання з курсу.<br/>
                    Також була звернута увага на рецензування, сертифікацію та початок викладання розроблених курсів.
                    На завершення зустрічі всі учасники передали привітання командам колег з прийдешніми Різдвяними і
                    Новорічними святами.
                    </>)
                }
            </p>
            <img style={{width:"75%"}} src={meeting1} alt="meeting"/>
        </div>
    )
}
export default OnlineNextMeeting;